"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cms_fetch_1 = __importDefault(require("~/helpers/cms-fetch"));
exports.default = (0, cms_fetch_1.default)('pages/?type=books.Book&fields=title,id,book_state,promote_snippet&limit=250')
    .then((r) => r.items);
